
const booking = {
    name: 'Nombre',
    description: 'Descripción',
    allowReservations: 'Permitir reservas',
    reservationRequired: 'Requiere reserva',
    reservable: 'Reservable',
    PVPHosted: 'Precio huesped',
    PVPNoHosted: 'Precio no huesped',
    noEvents: 'No hay más actividades programadas para el día de hoy',
    moreInfo: '+ info',
    cancelReservation: 'Cancelar r.',
    reservation: 'Reservar',
    addCalendar: '+ CAL',
    place: 'Lugar',
    meetingPoint: 'Punto de encuentro',
    lat: 'Latitud',
    lon: 'Longitud',
    complete: 'Completo',
    allowReservation: 'Permitir reservar',
    imagesFolder: 'Carpeta de imágenes',
    pleaseStandBy: 'Por favor espere',
    filter: 'Filtro',
    info: 'Info',
    typeLimit: {
      days: 'días',
      minutes: 'minutos',
      hours: 'horas',
      from: 'desde',
      to: 'hasta',
      before: 'antes',
      canBeReserved: 'Se puede reservar',
    },
    acttiv: {
      hotel: 'Hotel',
    },
    activities: {
      title: 'Actividades',
      addActivity: 'Añadir actividad',
      editActivity: 'Editar actividad',
      seats: 'Plazas',
    },
    schedules: {
      title: 'Programaciones',
      addSchedule: 'Añadir programación',
    },
    scheduleForm: {
      title: 'Programa',
      alias: 'Alias',
      startTime: 'Hora inicio',
      interval: 'Intervalo',
      type: 'Tipo',
      byDay: 'Por fechas',
      byWeek: 'Por semanas',
      byMonth: 'Por mes',
      allDay: 'Todo el día',
      duration: 'Duración',
    },
    formFields: {
      owner: 'Comprador',
      pax: 'Asistente',
      title: 'Campos del formulario',
      name: 'Nombre',
      lastName: 'Apellidos',
      email: 'Email',
      fullName: 'Nombre completo',
      phone: 'Teléfono',
      room: 'Habitación',
      locale: 'Idioma',
      age: 'Edad',
      allergens: 'Alérgenos',
      observations: 'Observaciones',
      add: 'Añadir',
      type: 'Tipo',
    },
    calendar: {
      today: 'Hoy',
      day: 'Día',
      week: 'Semana',
      month: 'Mes',
      fourDays: '4 días',
      available: 'Disponibles',
      reserved: 'Reservadas',
      canceled: 'Canceladas',
      goToReservationList: 'Ir al listado de reservas', 
    },
    notifications: {
      title: 'Notificaciones',
      sendOwnerMail: 'Enviar email de reserva al cliente',
    },
    reservations: {
      title: 'Reservas',
      numPax: 'Número de asistentes',
      field: 'Campo',
      addReservation: 'Añadir reserva',
      editReservation: 'Editar reserva',
      clientData: 'Datos del cliente',
      paxData: 'Datos de participantes',
      addPax: 'Añadir participante',
      pax: 'Participante',
      owner: 'Cliente',
      time: 'Hora',
      activity: 'Actividad',
      cu: 'Creado por',
      lmu: 'Actualizado por',
      withBooks: 'con reservas',
      withCancelBooks: 'con reservas canceladas',
      required: 'Requerido',
      key: 'Identificador interno',
      label: 'Etiqueta',
      terms: 'Condiciones de uso',
      exceededCapacity: 'Aforo excedido',
      limitFieldsTime: 'Límite de reservas por cliente excedido',
      adultsPax: 'Adultos',
      childrensPax: 'Niños',
      babiesPax: 'Bebés',
      rate: 'Tarifa',
      activityColor: {
        typeColor: 'Tipo',
        weekPrimaryColor: 'Semana primario',
        weekSecondaryColor: 'Semana secundario',
        contentColor: 'Color contenido',
        titleColor: 'Color título',
        timeColor: 'Color hora',
      },
      formFieldsTypes: {
        title: 'Tipo',
        text: 'Texto',
      },
      status: {
        title: 'Estado',
        default: 'Reservado',
        canceled: 'Cancelado',
      },
      messages: {
        fieldRequired: 'Requerido',
        fieldNotValid: 'No válido',
        noData: 'No existen reservas para la fecha seleccionada',
        noEventsForSelectedDate: 'No existen eventos para la fecha seleccionada',
        statusCanceledNoEditable: 'Las reservas canceladas no se pueden editar',
        exceededCapacity: 'Aforo excedido',
        limitFieldsTime: 'Límite de reservas por cliente excedido',
        resourceNotAvailable: 'Recurso no disponible',
      },
    },
}
export default booking
